import { HttpErrorResponse } from "@angular/common/http";
import { InjectionToken, Type } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { BehaviorSubject, Observable } from "rxjs";
import { IIssueTransactionView, ITransactionSummaryView } from "../../../interfaces";

export const STEP_FORM_GROUP = new InjectionToken('STEP_FORM_GROUP');
export const ISSUE_FORM_GROUP = new InjectionToken('ISSUE_FORM_GROUP');

export class Step {
    title: () => Observable<string>;
    formGroup: FormGroup;
    view: Type<IIssueTransactionView>;
    summaryView: Type<ITransactionSummaryView>;
    isHidden: boolean;
    role: string;
    status: BehaviorSubject<number>;
    visibleInConclusion: boolean;
    errors?: HttpErrorResponse[];
}

export const StepStatus = {
    'NoAction': -1,
    'Pending': 0,
    'Started': 1,
    'Succeeded': 2,
    'Failed': 3
}
